<template>
	<div class="organization-user-companies">
		<div class="organization-user-companies__sticky-top">
			<div class="flex ai-c jc-sb mb-sm">
				<h4 class="ma-0">{{ `${'Société'.pluralize(setup.count, true)}` }}</h4>
				<shared-company-flat-select
					v-if="!readonly && (setup.self.can('UserUpdate') && !userIsAgencyWatchingClient) && setup.isOrganizationUser() && !setup.self.suiteUserId"
					:model-value="setup.companiesWithMemberships"
					:user="setup.props.user"
					display-add-all
					@add="setup.refreshListAsync()"
					@delete="setup.refreshListAsync()"/>
				<o-button
					v-if="!readonly && (setup.self.can('UserUpdate') && !userIsAgencyWatchingClient) && setup.isOrganizationUser() && setup.self.suiteUserId"
					color="info"
					nude
					@click="setup.goToSuiteMemberships()">
					Associer à une société
				</o-button>
			</div>
		</div>

		<shared-paged-list-order-header
			v-if="setup.companies.length"
			v-model="setup.filter.order"
			:orders="setup.orderConfig.orders"
			hide-selection
			@refresh-list="setup.refreshListAsync(true)"/>

		<o-list
			v-model:page="setup.page"
			:list="setup.companies"
			:total="setup.count"
			:use-pagination-top="false"
			layout="row"
			@paginate="setup.refreshListAsync()">
			<template #default="{ item }">
				<div class="organization-user-companies__list-item">
					<div>
						<div><strong>{{ item.name }}</strong></div>
						<div
							v-if="item?.contactDetailCity && item?.contactDetailPostCode"
							class="organization-user-companies__list-item-company-city">
							{{ item?.contactDetailCity }}<span class="median-point"/>{{ item?.contactDetailPostCode }}
						</div>
					</div>

					<o-label
						v-if="setup.self.isClient()"
						class="organization-user-companies__list-item-label"
						color="default"
						outline>
						{{
							item.agencyCompany && item.agencyCompany.name
								? item.agencyCompany.name
								: item.agencyCompanyName
						}}
					</o-label>

					<div
						v-if="(setup.self.can('UserUpdate') && !userIsAgencyWatchingClient) && setup.isOrganizationUser()
							&& !setup.props.user.isSelf && !setup.props.user.isCreator && !setup.self.suiteUserId"
						class="organization-user-companies__list-item-actions">
						<o-pop-confirm @confirm="setup.deleteMembershipAsync(item)">
							<o-icon
								v-tooltip="`Supprimer le lien avec la société`"
								ripple="danger"
								font-icon="icon-interface-delete-bin-2"
								class="text--danger"/>
						</o-pop-confirm>
					</div>
				</div>
			</template>
		</o-list>

		<o-alert
			v-if="!setup.count"
			color="info"
			center>
			Aucune société n'est associée à cet utilisateur
		</o-alert>
	</div>
</template>

<script setup lang="ts">
import OrganizationUserCompaniesSetupService from '@/setup/organization-user/OrganizationUserCompaniesSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
const props = defineProps(OrganizationUserCompaniesSetupService.props);
const setup = new OrganizationUserCompaniesSetupService(props, _aside);
</script>

<style scoped lang="less">
.organization-user-companies {
	&__sticky-top {
    position: sticky;
		top: -4rem;
		padding: 1rem 0;
		background-color: white;
		z-index: 10;
	}

	&__list-item {
    padding: 1rem 1.25rem;
    border-radius: 0.25rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		overflow: hidden;

		&:hover, &:active, &:focus {
			.organization-user-companies__list-item-actions {
				transform: translateX(0);
				opacity: 1;
      }

      .organization-user-companies__list-item-label {
        transform: translateX(-1rem);
			}
		}
  }

	&__list-item-company-city {
		color: var(--grey-dark);
		font-size: 0.8rem;
	}

	&__list-item-label {
		transition: all .3s;
    margin-left: auto;
	}

	&__list-item-actions {
		transition: all .3s;
		font-size: 1rem;
		opacity: 0;
		transform: translateX(3rem);
		cursor: pointer;
	}

	:deep(.shared-paged-list-order-header) {
    padding: 0 0.25rem;
    margin-bottom: var(--space-xs);

    > .row > .col {
      flex: 0;
    }
	}

  :deep(.orion-list__row), :deep(.orion-list__cell) {
    &:nth-of-type(odd) {
      background: rgba(var(--rgb-grey-lighter), 0.75);
    }

    +.orion-list__row {
      margin: unset;
    }
  }
}
</style>
